export default "__VITE_ASSET__1iR8kmZ9__"